import Vue from 'vue'
import App from './App.vue'
import VueStatic from "vue-static"


import { library } from '@fortawesome/fontawesome-svg-core'
import { faItunesNote } from '@fortawesome/free-brands-svg-icons'
import { faTint, faExpand, faInfo, faMobileAlt, faTshirt, faAngleUp, faMedal, faAppleAlt, faShoppingBag, faParking, faShower, faCaretDown, faCaretUp, faUser, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import "./global.css";

//Icon Setup. TODO: move
library.add(faItunesNote, faTint, faExpand, faInfo, faMobileAlt, faTshirt, faAngleUp, faMedal, faAppleAlt, faShoppingBag, faParking, faShower, faCaretDown, faCaretUp, faUser, faPlusCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueStatic, {namespaced:true})
Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
